<p>minimal-api-test works!</p>

<h4>Onboarding connection activation group</h4>

<h4>Trading deals</h4>

<ng-template [ngIf]="this.deals">
  <ngx-json-viewer [json]="this.deals"></ngx-json-viewer>
</ng-template>